export default function getDesignVariantImage(uuid: string, image: string): string {
  const cdnUrl = import.meta.env.VITE_CDN_URL || "https://cdn.region.game/";
  return [cdnUrl, "images/", "interior-props/", uuid, "/", image].join("");
}
